export default "__VITE_ASSET__CLVPJvLZ__"